export const ActionTypes = {
  REQUEST: "ADMIN_FETCH_USER_HABITS_REQUEST",
  SUCCESS: "ADMIN_FETCH_USER_HABITS_SUCCESS",
  FAILURE: "ADMIN_FETCH_USER_HABITS_FAILURE",

  SUCCESS_SINGLE: "ADMIN_FETCH_USER_HABIT_SUCCESS",
  UPDATE_SUCCESS: "ADMIN_UPDATE_USER_HABIT_SUCCESS",
  CREATE_SUCCESS: "ADMIN_CREATE_USER_HABIT_SUCCESS",
  DELETE_SUCCESS: "ADMIN_DELETE_USER_HABIT_SUCCESS",
}

export interface IUserHabit {
  id: number;
  parent_subcategory: number;
  type: number;
  custom_habit_name: string;
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
  duration: string | null;
  starts: string | null;
  note: string;
  scoring_type: string;
  motivation: string;
  trigger: string;
  obstacle: string;
  belief: string | null;
  date: string | null;
  is_periodic: boolean;
  periodic_type: string | null;
  repeat_monday: string | null;
  repeat_tuesday: string | null;
  repeat_wednesday: string | null;
  repeat_thursday: string | null;
  repeat_friday: string | null;
  repeat_saturday: string | null;
  repeat_sunday: string | null;
  periodic_start_date: string | null;
  periodic_end_date: string | null;
  periodic_time: string | null;
  periodic_server_time: string | null;
  periodic_duration_hours: string | null;
  periodic_duration_minutes: string | null;
  repetition_frequency: string | null;
  repetition_type: string | null;
  repeat_days_in_month: string | null;
  is_key_stone_habit: boolean;
  is_private: boolean;
  habit_status: string;
  last_notified_date: string | null;
  current_streak: number;
  current_streak_from: string;
  current_streak_to: string;
  best_streak: number;
  best_streak_from: string;
  best_streak_to: string;
}

interface NormalizedEntities {
  [key: string]: IUserHabit;
}

export interface IState {
  entities: NormalizedEntities;
  ids: string[];
  count: number;
  loading: boolean;
  error: any;
}